// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__hQ4fJ","nav-link":"Navbar_nav-link__1X3al"};